export enum BadgePlacements {
  TOP = 'top',
  LEFT = 'left',
  RIGHT = 'right',
  BOTTOM = 'bottom',
  TR = 'topRight',
}
export enum ModalProps {
  CONFIRM_TEXT = 'Confirm',
  EMPTY_STRING = '',
}

export enum ButtonProps {
  COLOR = 'delete',
}
export enum ButtonLabels {
  CLOSE = 'Close',
  DELETE = 'Delete',
  CANCEL = 'Cancel',
  BACK = 'Go Back',
}
